import {combineReducers} from "redux";
import userReducer from "./reducer";

const reducer = combineReducers({
    userReducer,
})
  
export default reducer;